import styled from 'styled-components'

export const Container = styled.div`
  background-color: ${props => props.theme.colors.background.primary};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  overflow: hidden;
`

export const BlocksContainer = styled.div`
  background-color: ${props => props.theme.colors.background.secondary};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const BlockItem = styled.div`
  background-color: ${props => props.theme.colors.background.primary};
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
  padding: 4px ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius2};

  #draggable-icon {
    cursor: grab;
    flex-shrink: 0;
  }
`

export const BlockTexts = styled.div`
  display: flex;
  flex-direction: column;
`
